<div class="mt-5 d-flex justify-content-center">
  <div>
    <i *ngIf="icon" [class]="'red mr-2 ' + icon"></i>
    <span class="red">{{ t | i18next }}</span>
  </div>
</div>
